export const SHOW_SIGN_UP_FORM_QUERY_PARAM = 'show_signup_form'
export const SHOPPERS_FORM_ID = 'shoppers-signup-form'

export const createSignupLink = (currentHost: string): void => {
  window.location.href = `${currentHost}?${SHOW_SIGN_UP_FORM_QUERY_PARAM}=true`
}
